import React from "react"
import { Link } from "gatsby"
import tw, { styled } from "twin.macro"
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image"

import PowerSVG from "../../assets/energy.inline.svg"
import BroadbandSVG from "../../assets/broadband.inline.svg"
import GasSVG from "../../assets/gas.inline.svg"
import PhoneSVG from "../../assets/phone.inline.svg"
//import EvSVG from "../../assets/ev.inline.svg"
//import SolarSVG from "../../assets/solar-new.inline.svg"

import Slat from "@ui-kit/atoms/slat/icon-with-text"
import SlatGroup from "@ui-kit/organisms/slat-group"
import Card from "@ui-kit/atoms/card/basic"
import Carousel from "@ui-kit/molecules/carousel"

/*
type BannerType = {
    title?: string,
    body?: {
        html: string
    },
    r: {
        banner: any,
        cards: Array<any>
    }
}*/

const Cards = (cards) => (
  <Carousel
    className="cards carousel banner__article"
    timeout={10000}
    items={cards.map((card, i) => (
      <Card key={i}>
        <strong>{card.title}</strong>
        <div dangerouslySetInnerHTML={{ __html: card.body.html }} />
        {/*<DrupalLink to={card.link.uri}><Pill coloured elem="span">{card.link.title}</Pill></DrupalLink>*/}
      </Card>
    ))}
  />
)

const Banner = ({ title, body, r, ...props }) => {
  if (r === undefined) {
    return
  }
  const { banner, cards } = r

  return (
    <Style {...props}>
      {banner ? (
        <div tw="h-full flex-1" className="banner__inner">
          <GatsbyImage
            image={withArtDirection(getImage(banner.media.image.file.large), [
              {
                media: `(max-width: 599px)`,
                image: getImage(banner.media.image.file.small),
              },
            ])}
            {...banner.meta}
            objectPosition={"top"}
          />

          {cards.length > 0 && <Cards cards={cards} />}
        </div>
      ) : (
        <div tw="h-full flex-1" className="banner__inner-alternate">
          <Cards />
        </div>
      )}

      {title && (
        <BannerFooter className="banner__footer">
          <BannerBottomEdge>
            <SlatGroup>
              {[
                {
                  title: "Join us",
                  uri: `https://novaenergy.my.salesforce-sites.com/WebResApplication`,
                  options: {
                    attributes: {
                      class: "icon--pencil theme--primary",
                    },
                  },
                },
                {
                  title: "Compare plans",
                  uri: "/broadband",
                  options: {
                    attributes: {
                      class: "icon--compare theme--primary",
                    },
                  },
                },
                {
                  title: "Nova Hub",
                  uri: "https://www.novahub.co.nz/",
                  options: {
                    attributes: {
                      class: "icon--account theme--primary",
                    },
                  },
                },
              ].map((link, i) => {
                const Elem = link.uri.includes("http") ? OutboundLink : Link
                const prop = link.uri.includes("http")
                  ? { href: link.uri, target: "_blank", rel: "noopener" }
                  : { to: link.uri }

                return (
                  <Elem key={i} {...prop}>
                    <Slat {...link.options}>
                      <h4>{link.title}</h4>
                    </Slat>
                  </Elem>
                )
              })}
            </SlatGroup>
          </BannerBottomEdge>

          <q>{title}</q>
          {body && (
            <div
              tw="max-w-xl mx-auto px-4"
              dangerouslySetInnerHTML={{ __html: body.html }}
            />
          )}
          <ul>
            {[
              PowerSVG,
              BroadbandSVG,
              GasSVG,
              PhoneSVG,
              //EvSVG,
              //SolarSVG
            ].map((Icon, i) => (
              <li key={i}>
                <Icon tw="w-10 lg:w-16 h-auto" />
              </li>
            ))}
          </ul>
        </BannerFooter>
      )}
    </Style>
  )
}
export default Banner

const OutboundLink = ({ children, ...props }) => <a {...props}>{children}</a>

const Style = styled.div`
  ${tw`
        sm:[height:calc(100vh - 150px)]
        grid
        [gridTemplateRows:minmax(400px, 55vh) 1fr]
        overflow-hidden
    `}

  @media (max-height: 1150px) {
    ${tw`lg:[minHeight:900px]`}
  }

  .gatsby-image-wrapper {
    ${tw`h-full flex-1 z-10 `}
  }

  .banner__inner {
    ${tw`relative`}

    > .carousel {
      ${tw`[zIndex:11] absolute top-0 sm:[left:7vmin] sm:[right:7vmin] h-full`}

      > .carousel__inner {
        ${tw`px-4 sm:px-0`}
      }
    }
  }
`

const BannerFooter = styled.div`
  ${tw`
        bg-primary
        antialiased
        text-white
        text-center
        mt-auto
        py-6
        md:py-14
        lg:py-6
        mg:py-14
        relative
        sm:h-full
        z-20
        md:portrait:flex
        md:portrait:flex-col
        md:portrait:justify-center
    `}

  q {
    ${tw`
            font-display
            [fontSize:clamp(2rem, 5vmax, 80px)]
            leading-tight
        `}

    &::before,
        &::after {
      content: none;
    }
  }

  p {
    ${tw`
            text-xl
            mt-0
            text-gray-600
        `}
  }

  ul {
    ${tw`list-none mb-0 flex flex-wrap px-4 gap-x-6 gap-y-3 lg:gap-x-16 mg:gap-x-24 justify-center items-center mt-6`}
  }
`

export const BannerBottomEdge = styled.div`
  ${tw`
        sm:absolute
        w-full
        max-w-2xl
        sm:left-1/2
        top-0
        [transform:translateY(-50%)]
        sm:[transform:translateX(-50%) translateY(-90%)]

        mg:[transform:translateX(-50%) translateY(-70%)]
    `}
`
